import { AbstractPreset, config } from "./AbstractPreset";

export default class CircleCircleNone extends AbstractPreset {
	getName(): string {
		return 'circleCircleNone';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "circle",
				"presetShape": this.getName(),
				"primitives": {
					"diameter": 50
				},
			},
			"drillholes": {
				"type": "none"
			},
			"cutouts": [
				{
					"type": "shape",
					"shape": "circle",
					"primitives": {
						"diameter": 25
					},
					"modifiers": [],
					"position": {
						"left": 250,
						"bottom": 250,
						"rotation": 0
					}
				}
			],
		};
	}

}
